// extracted by mini-css-extract-plugin
module.exports = {"CustomModal":"CustomModal_CustomModal__BpM3n","CloseAction":"CustomModal_CloseAction__H4Iv-"};